import { ApolloClient, InMemoryCache, split, createHttpLink } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
import { storageService } from 'services';
import { environment } from '../environments/environment';

function link(token = '') {
  const httpLink = createHttpLink({
    uri: `${environment.REACT_APP_BASE_URL}/graphql/`,
  });

  const wsLink = new WebSocketLink({
    uri: environment.REACT_APP_GRAPHQL_WS || '',
    options: {
      lazy: true,
      reconnect: true,
      connectionParams: {
        'access-token': token,
      },
    },
  });

  return split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpLink,
  );
}

const client = new ApolloClient({
  link: link(),
  cache: new InMemoryCache(),
});

client.onResetStore(async () => {
  const token: string = await storageService.get(storageService.ACCESS_TOKEN) || '';
  client.setLink(link(token));
});

export default client;
